import { useEffect, useState } from "react";
import { Phone, MessageCircle, Calendar } from "lucide-react";
import { api, resolveContact } from "@/lib/api";
import { buildWhatsAppLink, vehicleTitle } from "@/lib/format";

export const MobileStickyBar = ({ vehicle, onBookTestDrive }) => {
  const [settings, setSettings] = useState({});
  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);

  const { phone, whatsapp, phoneIsDemo, whatsappIsDemo } = resolveContact(settings);
  const waMsg = vehicle
    ? `Hi Carz Swag, I'm interested in the ${vehicleTitle(vehicle)}. Please share more details.`
    : "Hi Carz Swag, I'd like more information.";

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 p-2.5 flex gap-2 shadow-[0_-4px_12px_-6px_rgba(0,0,0,0.15)]" data-testid="mobile-sticky-bar">
      <a href={`tel:${phone}`} className="relative flex-1 inline-flex items-center justify-center gap-1.5 py-2.5 rounded-lg bg-[#111] text-white font-semibold text-sm" data-testid="mobile-call-btn">
        <Phone size={16} /> Call {phoneIsDemo && <Dot />}
      </a>
      <a href={buildWhatsAppLink(whatsapp, waMsg)} target="_blank" rel="noreferrer" className="relative flex-1 inline-flex items-center justify-center gap-1.5 py-2.5 rounded-lg text-white font-semibold text-sm" style={{ background: "#25D366" }} data-testid="mobile-whatsapp-btn">
        <MessageCircle size={16} /> WhatsApp {whatsappIsDemo && <Dot />}
      </a>
      {vehicle && (
        <button onClick={onBookTestDrive} className="flex-1 inline-flex items-center justify-center gap-1.5 py-2.5 rounded-lg bg-[#940C2C] text-white font-semibold text-sm" data-testid="mobile-test-drive-btn">
          <Calendar size={16} /> Test Drive
        </button>
      )}
    </div>
  );
};

const Dot = () => <span className="ml-0.5 inline-flex items-center bg-black/25 text-[9px] font-bold uppercase rounded px-1 py-0.5">DEMO</span>;
